<template>
<div>
	<div class="panel panel-default" v-if="!isUpdate">
		<ly-fixheader title="查看微信门店信息" btn="edit">
        	<div class="btn-group pull-right pr15" slot="s1">
				<a href="javascript:;" class="btn btn-block btn-primary pull-right" v-if="info.is_wx == 0" @click="setWeinxin"> 
					<i class="glyphicon glyphicon-eye-open"></i>
					设为微信可见
				</a>
				<a href="javascript:;" class="btn btn-block btn-primary pull-right" v-if="info.is_wx == 1" @click="setWeinxin"> 
					<i class="glyphicon glyphicon-eye-close"></i>
					设为微信不可见
				</a>
			</div>
		</ly-fixheader>
  		<div class="panel-body">
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-2 control-label">所属管理公司:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.company}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">门店名称:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.shop}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">门店ID:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.shop_id}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">门店微信中显示名称:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.name}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">区域:</label>
					<div class="col-sm-10">
						<label class="control-label">{{area}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">详细地址:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.address}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">门店电话:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.phone}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">服务时间:</label>
					<div class="col-sm-10">
						<label class="control-label">{{info.work_time}}~{{info.rest_time}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">腾讯地图坐标值:</label>
					<div class="col-sm-10">
						<label class="control-label" v-if="info.coordinate">{{info.coordinate}}</label>
						<label class="control-label" v-else>无</label>
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group" v-if="info.shop_img && info.shop_img.length > 0">
					<label class="col-sm-2 control-label">门店照片:</label>
					<div class="col-sm-10">
						<img class="imgsize" v-for="e in info.shop_img" track-by="$index" :src="e">
					</div>
				</div>
			  	<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">提供服务项目:</label>
					<div class="col-sm-10">
						<label class="control-label" v-for="item in info.servicelist">{{item}}&nbsp;&nbsp;</label>
					</div>
				</div>
			</form>
		</div>
  	</div>
	<ly-shopupdate v-if="isUpdate" :info="info"></ly-shopupdate>
</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var info = {};//公司详情
	module.exports = {
		data : function(){
			return {
				isUpdate: false,
				info :{},
				area: ""
			}
		},
		components : {
			'ly-shopupdate' : require('./shop_add.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue')
		},
		ready : function () {
			var self = this;
			var sid = this.$route.params['sid'];//获得公司的ID
			Http['shop'].query({
				key : [sid],
				succ : function(rs){
					rs['id'] = sid;
					self.$set('info',rs);
					self.area = rs.area.join('');//直接写在html里报错 join undefined
				}
			});
		},
		methods: {
			
			/**
			* 设为微信可见/不可见
			*/
			setWeinxin: function(){
				var sid = this.$route.params['sid'];//获得技师的ID
				var self = this;
				if(this.info.is_wx == 1) {
					Common.confirm('确定要设为微信不可见吗?', function(){
						Http['shop'].delete({
							key: [sid, 1],
							data: {
								status: 0,
								is_wx: 0
							},
							succ: function(rs){
								self.info.is_wx = 0;
								Common.tipDialog('成功设为微信不可见',1500,'success');
							},
							err: function(rs){
								Common.tipDialog(rs,1500,'error');
							}
						});
					});	
				} else if(this.info.is_wx == 0) {
					Common.confirm("确定要设为微信可见吗?",function(){
						Http['shop'].createStatus({
							key : [sid],
							data: {
								status: 0,
								is_wx: 1
							},
							succ : function(rs){
								self.info.is_wx = 1;
								Common.tipDialog("成功设为微信可见!",1500,"success");
							},
							err : function(rs) {
								Common.tipDialog(rs,1500,"success");
							}
						});
					});
				}
			}
		},
		events : {
			doUpdate : function(){
				this.isUpdate = true;
			},
			closeUpdate : function(){
				this.isUpdate = false;
			},
			goback: function(){
				Common.go('shop_list');
			}
		}
	};
</script>


/** WEBPACK FOOTER **
 ** shop_info.vue?2befd051
 **/